import React from 'react';
import { Route, Switch } from 'react-router';
import Welcome from '../modules/Welcome/Welcome';
import Login from '../modules/Login/components/Login.jsx';
import Registration from '../modules/Login/components/Registration.jsx';
import PrivateRoute from './PrivateRoute.jsx';
import AccountWrapper from '../modules/Account/components/AccountWrapper.jsx';
import Trade from '../modules/Account/components/Trade.js';
import ForgotPassword from '../modules/Login/components/ForgotPassword.jsx';
import ResetPassword from '../modules/Login/components/ResetPassword.jsx';
import Verify from '../modules/Verify/Verify.jsx';
import Confirm from '../modules/Login/components/Confirm.jsx';
import ErrorBoundary from './ErrorBoundary.jsx';
import CreatedAccounts from '../modules/CreatedAccounts/CreatedAccounts';
import MobileAppLinks from '../modules/MobileAppLinks/MobileAppLinks';
import { Cashier } from '../modules/Cashier/Cashier';
import { MobileInProgress } from '../modules/MobileInProgress/MobileInProgress';
import { Support } from '../modules/Support/Support';
import { FEATURES, RouterPaths } from './appConstants';
import { PrivacyPolicy } from "../modules/PrivacyPolicy/PrivacyPolicy";
import { BrokenLink } from "../modules/Login/components/BrokenLink";
import { WELCOME_PAGE_VERSION } from "../modules/Welcome/welcomeConstants";
import { OnboardingRoute } from "../modules/Onboarding/OnboardingRoute";
import MobileDepositBonus from "../modules/MobileBonus/MobileDepositBonus/MobileDepositBonus";
import { Contacts } from "../pages/Contacts/Contacts";
import PartnerRoute from "../modules/Partner/PartnerRoute.jsx";
import MobileGift50Bonus from "../modules/MobileBonus/MobileGift50Bonus/MobileGift50Bonus";
import MobileBonus from "../modules/MobileBonus/MobileBonus";
import PartnerPublicDocs from "../modules/Partner/PartnerPublicDocs.jsx";
import PageNotFound from "./PageNotFound";
import AutoLogin from "../modules/Login/components/AutoLogin";
import { useLangContext } from "../providers/LangProvider/LangProviderContext.js";
import PromoRoute from "../modules/Promo/PromoRoute";
import { Promotions } from "../pages/Promotions.jsx";
import NewLifePage from "../pages/NewLifePage.jsx";

const RoutePage = () => {
    const {getLangPath} = useLangContext();
    return (
        <ErrorBoundary
            headerText={getLangPath('error.default_message')}
            linkText={(getLangPath('error.go_back'))}
        >
            <Switch>
                <Route exact path={RouterPaths.main} component={Welcome}/>
                <Route exact path={RouterPaths.mainRedesign}
                       render={(props) => <Welcome {...props} version={WELCOME_PAGE_VERSION.REDESIGN}/>}/>
                <Route exact path={RouterPaths.login} component={Login}/>
                <Route exact path={RouterPaths.registration} component={Registration}/>
                <Route exact path={RouterPaths.confirm} component={Confirm}/>
                <Route exact path={RouterPaths.forgot} component={ForgotPassword}/>
                <Route exact path={RouterPaths.reset} component={ResetPassword}/>
                <Route exact path={RouterPaths.mobileInProgress} component={MobileInProgress}/>
                <Route exact path={RouterPaths.privacyPolicy} component={PrivacyPolicy}/>
                <Route exact path={RouterPaths.support} component={Support}/>
                <Route exact path={RouterPaths.brokenLink} component={BrokenLink}/>
                <Route exact path={RouterPaths.contacts} component={Contacts}/>
                <Route exact path={RouterPaths.promotions} component={Promotions}/>
                <Route exact path={RouterPaths.partnerPublicDocs} component={PartnerPublicDocs}/>
                <Route exact path={RouterPaths.autoLogin} component={AutoLogin}/>
                <Route path={RouterPaths.promo} component={PromoRoute}/>
                <PrivateRoute path={RouterPaths.createdAccounts} component={CreatedAccounts}/>
                <PrivateRoute path={RouterPaths.mobileAppLinks} mobile component={MobileAppLinks}/>
                <PrivateRoute exact path={RouterPaths.mobileBonus} mobile component={MobileBonus}/>
                <PrivateRoute path={RouterPaths.mobileDepositBonus} mobile component={MobileDepositBonus}/>
                <PrivateRoute path={RouterPaths.mobileGift50Bonus} mobile component={MobileGift50Bonus}/>
                <PrivateRoute path={RouterPaths.verify} component={Verify}/>
                <PrivateRoute path={RouterPaths.partner} component={PartnerRoute}/>
                <PrivateRoute path={RouterPaths.trade} component={Trade} wrapper={AccountWrapper}/>
                <PrivateRoute path={RouterPaths.cashier} component={Cashier}/>
                <PrivateRoute path={RouterPaths.onboarding} mobile component={OnboardingRoute}/>
                <PrivateRoute path={RouterPaths.respawn} feature={FEATURES.NEW_LIFE} component={NewLifePage}/>
                <Route path="**" component={PageNotFound}/>
            </Switch>
        </ErrorBoundary>
    );
};

export default RoutePage;
